import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    const token = localStorage.getItem("agenda_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const { data } = await api.get("/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(null);
      localStorage.removeItem("agenda_token");
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    localStorage.removeItem("agenda_token");
    setUser(null);
    window.location.href = "/";
  };

  const setToken = async (token) => {
    localStorage.setItem("agenda_token", token);
    await fetchMe();
  };

  return (
    <AuthContext.Provider value={{ user, loading, logout, setToken, refresh: fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
